export default {
  // 授权状态（DeviceLicense 与 ProductionToken 烧录记录共用）
  'pages.deviceLicense.status.allocated': '已录入',
  'pages.deviceLicense.status.activated_pending': '已激活待接入',
  'pages.deviceLicense.status.active': '已接入',
  'pages.deviceLicense.status.serial_mismatch': '设备烧录序列号和平台下发不一致',
  'pages.deviceLicense.status.revoked': '已吊销',
  'pages.deviceLicense.status.expired': '已过期',
  'pages.deviceLicense.burnStatus.pending': '未烧录',
  'pages.deviceLicense.burnStatus.success': '烧录成功',

  // DeviceLicense
  'pages.deviceLicense.column.serialNumber': '产线序列号',
  'pages.deviceLicense.column.burnStatus': '烧录状态',
  'pages.deviceLicense.column.productionTokenName': '归属产线 Token',
  'pages.deviceLicense.rule.tenantRequired': '请选择所属企业',
  'pages.deviceLicense.rule.deviceIdRequired': '请输入设备MAC',
  'pages.deviceLicense.batch.tooltip': '支持逗号、空格或换行分隔，自动去重',
  'pages.deviceLicense.batch.devicesRequired': '请输入设备MAC列表',

  // TenantInfo
  'pages.tenantInfo.rule.nameRequired': '请输入企业名称',
  'pages.tenantInfo.type.commercial': '商业版',
  'pages.tenantInfo.type.legacy': '历史/零售',
  'pages.tenantInfo.type.internal': '内部',
  'pages.tenantInfo.status.active': '正常',
  'pages.tenantInfo.status.inactive': '停用',
  'pages.tenantInfo.maxDevices.tooltip': '该企业可授权/接入的设备上限；也可在列表中通过「新增接入数量」累加',
  'pages.tenantInfo.addMax.button': '新增接入数量',
  'pages.tenantInfo.addMax.success': '已累加，当前可接入设备总数：{count}',
  'pages.tenantInfo.addMax.failed': '操作失败',
  'pages.tenantInfo.addMax.incrementLabel': '本次增加数量',
  'pages.tenantInfo.addMax.incrementRequired': '请输入大于 0 的数量',

  // ProductionToken
  'pages.productionToken.title': '产线烧录 Token',
  'pages.productionToken.filterHint': '当前列表已按产品分类（ID: {id}）筛选，可在地址栏去掉参数查看全部。',
  'pages.productionToken.firmware.currentNoCategory': '{version}（当前，无产品分类绑定）',
  'pages.productionToken.firmware.currentNotInList': '{version}（当前/未在列表）',

  'pages.productionToken.column.tenant': '所属企业',
  'pages.productionToken.column.productCategoryId': '产品分类 ID',
  'pages.productionToken.column.name': '名称',
  'pages.productionToken.column.boardType': '主板型号',
  'pages.productionToken.column.status': '状态',
  'pages.productionToken.column.burnedLimit': '已签发/上限',
  'pages.productionToken.column.serialIssued': '已签发序列号',
  'pages.productionToken.column.autoAllocate': '自动分配MAC',
  'pages.productionToken.column.serialPrefix': '序列前缀',
  'pages.productionToken.column.lastUsedAt': '最近使用',
  'pages.productionToken.column.expiresAt': 'Token 过期',

  'pages.productionToken.status.enabled': '启用',
  'pages.productionToken.status.disabled': '停用',
  'pages.productionToken.yes': '是',
  'pages.productionToken.no': '否',

  'pages.productionToken.action.burnRecords': '烧录记录',
  'pages.productionToken.action.edit': '编辑',
  'pages.productionToken.action.rotate': '轮换',
  'pages.productionToken.action.add': '新建 Token',
  'pages.productionToken.confirm.delete': '确定删除？',

  'pages.productionToken.msg.rotateFailed': '轮换失败',
  'pages.productionToken.msg.deleted': '已删除',
  'pages.productionToken.msg.deleteFailed': '删除失败',
  'pages.productionToken.msg.createSuccess': '创建成功',
  'pages.productionToken.msg.createFailed': '创建失败',
  'pages.productionToken.msg.saved': '已保存',
  'pages.productionToken.msg.saveFailed': '保存失败',
  'pages.productionToken.msg.loadBurnFailed': '加载烧录记录失败',

  'pages.productionToken.rule.tenantRequired': '请选择企业',
  'pages.productionToken.rule.categoryRequired': '请选择产品分类',

  'pages.productionToken.add.title': '新建产线 Token',
  'pages.productionToken.add.categoryLabel': '产品分类（主板型号）',
  'pages.productionToken.add.categoryTooltip':
    '从本企业已维护的产品分类中选择；主板型号取分类中的「产品设备型号」，与 OTA board.type、ota_bin 子目录一致',
  'pages.productionToken.add.firmwareTooltip': '不选则使用产线默认或该分类最新固件；选项来自该产品分类已上传的固件',
  'pages.productionToken.add.autoAllocateTooltip': '关闭时仅允许已预录入 MAC 的设备拉取授权',
  'pages.productionToken.add.expiresTooltip': '可选，仅选日期；不选表示不过期',

  'pages.productionToken.edit.title': '编辑产线 Token',
  'pages.productionToken.edit.firmwareTooltip': '不选则使用产线默认或该分类最新固件；选项来自 Token 绑定分类下的固件列表',
  'pages.productionToken.edit.expiresTooltip': '可选；清空后保存则不在此修改过期时间（清除过期需后续接口支持）',

  'pages.productionToken.field.firmwareVersion': '锁定固件版本',
  'pages.productionToken.field.serialPrefix': '序列号前缀',
  'pages.productionToken.field.autoAllocate': '自动分配 MAC 授权',
  'pages.productionToken.field.maxBurnCount': '最大烧录次数',
  'pages.productionToken.field.maxBurnTooltip': '0 表示不限制',
  'pages.productionToken.field.expiresAt': 'Token 过期时间',
  'pages.productionToken.field.remark': '备注',
  'pages.productionToken.field.status': '状态',

  'pages.productionToken.placeholder.selectVersion': '请选择版本',
  'pages.productionToken.placeholder.selectCategoryFirst': '请先选择产品分类',

  'pages.productionToken.secret.title': '请立即保存（关闭后无法再次查看明文 Token）',
  'pages.productionToken.secret.saved': '已保存',
  'pages.productionToken.secret.urlLabel': '授权 URL 模板（写入烧录工具 config.json 的 license_url）',

  'pages.productionToken.burn.title': '烧录记录',
  'pages.productionToken.burn.titleWith': '烧录记录 — {name}',
  'pages.productionToken.burn.boardInfo': '主板型号：{boardType}；已签发序列号设备数：',
  'pages.productionToken.burn.limitSuffix': ' / 上限 {max}',
  'pages.productionToken.burn.column.deviceId': '设备 MAC',
  'pages.productionToken.burn.column.serialNumber': '产线序列号',
  'pages.productionToken.burn.column.status': '授权状态',
  'pages.productionToken.burn.column.boardType': '型号',
  'pages.productionToken.burn.column.burnedAt': '签发时间',
  'pages.productionToken.burn.column.activatedAt': '首次接入',
  'pages.productionToken.burn.column.source': '来源',

  // 通用（多页共享）
  'pages.common.operation': '操作',
  'pages.common.deleteSuccess': '删除成功',
  'pages.common.deleteFailed': '删除失败',
  'pages.common.saveSuccess': '保存成功',
  'pages.common.saveFailed': '保存失败',

  // Tenant（企业：列表列/表单/枚举共享，TenantInfo 使用）
  'pages.tenant.logo.typeError': '只能上传图片文件',
  'pages.tenant.logo.sizeError': '图片大小不能超过 1MB',
  'pages.tenant.logo.success': '上传成功',
  'pages.tenant.logo.uploadFailed': '上传失败',
  'pages.tenant.logo.upload': '上传Logo',
  'pages.tenant.logo.clear': '移除',
  'pages.tenant.modal.title': '企业信息',
  'pages.tenant.modal.profileTitle': '维护企业资料',
  'pages.tenant.column.code': '授权编码',
  'pages.tenant.code.tip': '授权编码由系统生成，不可修改',
  'pages.tenant.code.auto': '保存后自动生成',
  'pages.tenant.column.name': '企业名称',
  'pages.tenant.column.type': '类型',
  'pages.tenant.column.status': '状态',
  'pages.tenant.column.maxDevices': '可接入设备总数',
  'pages.tenant.column.contactName': '联系人',
  'pages.tenant.column.contactPhone': '联系电话',
  'pages.tenant.column.expiresAt': '到期时间',
  'pages.tenant.column.remark': '备注',
  'pages.tenant.column.supplierLogo': '企业Logo',
  'pages.tenant.column.activatedDevices': '激活设备数量',
  'pages.tenant.column.licensedDevices': '已授权设备数量',
  'pages.tenant.column.availableDevices': '可授权设备数量',
  'pages.tenant.maxDevices.unlimited': '不限制',
  'pages.tenant.confirm.delete': '确定删除该企业吗？',
  'pages.tenant.add': '新增企业',

  // License（设备授权：列表列/表单共享，DeviceLicense 使用）
  'pages.license.column.tenant': '所属企业',
  'pages.license.column.deviceId': '设备MAC',
  'pages.license.column.status': '状态',
  'pages.license.column.batchNo': '批次号',
  'pages.license.column.boardType': '型号',
  'pages.license.column.source': '授权来源',
  'pages.license.source.manual': '手工录入',
  'pages.license.source.import': '批量导入',
  'pages.license.source.production': '产线签发',
  'pages.license.source.production_preregister': '产线预录入',
  'pages.license.source.legacy_migrate': '历史迁移',
  'pages.license.column.activatedAt': '首次接入',
  'pages.license.column.createdAt': '录入时间',
  'pages.license.column.expiresAt': '到期时间',
  'pages.license.confirm.delete': '确定删除该授权吗？',
  'pages.license.add': '添加授权',
  'pages.license.batchAdd': '批量导入',
  'pages.license.modal.addTitle': '添加设备授权',
  'pages.license.batch.title': '批量导入设备授权',
  'pages.license.batch.devices': '设备MAC',
  'pages.license.batch.result': '导入完成：成功 {added}，跳过 {skipped}',

  // TenantLocationConfig（企业定位 Key 配置）
  'pages.tenantLocationConfig.title': '企业定位 Key 配置',
  'pages.tenantLocationConfig.selectTenant': '选择目标企业（可搜索名称/编码）',
  'pages.tenantLocationConfig.selectTenantFirst': '请先在上方选择目标企业，再查看或修改其定位 Key 配置。',
  'pages.tenantLocationConfig.noRecord': '暂无配置记录：该企业未配置独立 Key，当前使用平台公共 Key。',
  'pages.tenantLocationConfig.tagPlatform': '未建档（平台 Key）',
  'pages.tenantLocationConfig.tagEnabled': '已启用',
  'pages.tenantLocationConfig.tagDisabled': '已停用',
  'pages.tenantLocationConfig.currentTitle': '当前配置',
  'pages.tenantLocationConfig.editTitle': '修改配置',
  'pages.tenantLocationConfig.validateTitle': '校验结果',
  'pages.tenantLocationConfig.gpsLabel': 'GPS 逆地理 — 高德 Web 服务 Key',
  'pages.tenantLocationConfig.ipLabel': 'IP 归属地 — 阿里云云市场 AppCode',
  'pages.tenantLocationConfig.naviLabel': '导航路线 — 高德 Web 服务 Key',
  'pages.tenantLocationConfig.enabledLabel': '启用企业 Key',
  'pages.tenantLocationConfig.notConfigured': '未配置',
  'pages.tenantLocationConfig.loadFailed': '加载企业定位配置失败',
  'pages.tenantLocationConfig.saveFailed': '保存失败',
  'pages.tenantLocationConfig.saved': '已保存并实时生效（跨实例缓存已失效，最迟约 1 分钟内全量生效）',
  'pages.tenantLocationConfig.clearFailed': '清空失败',
  'pages.tenantLocationConfig.cleared': '已清空并实时生效',
  'pages.tenantLocationConfig.validateFailed': '校验请求失败',
  'pages.tenantLocationConfig.validatePassed': '校验通过',
  'pages.tenantLocationConfig.validatePartial': '校验完成：存在失败项，请查看下方结果',
  'pages.tenantLocationConfig.validateEmpty': '尚未配置任何 Key，无需校验',
};
